module.exports = __webpack_public_path__ + "img/2. 3 HAIR BUNDLES, TEST STRANDS.jpg";